



































import { computed, defineComponent, ref, toRefs } from '@nuxtjs/composition-api'
import CConfirmationModal from '~/components/shared/configurable/modal/CConfirmationModal.vue'
import { useDeps } from '~/compositions/dependency-container'
import AuditRequestService from '~/services/audits/AuditRequestService'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import CTextArea from '~/components/shared/configurable/form/input/CTextArea.vue'
import { useNamespacedStore } from '~/compositions/store'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'

export default defineComponent({
  components: { CTextArea, CConfirmationModal },
  props: {
    auditRequestId: {
      type: Number,
      required: true
    },
    actionText: {
      type: String,
      required: false,
      default: ''
    },
    confirmText: {
      type: String,
      required: false,
      default: ''
    }
  },
  setup(props, { emit }) {
    const { auditRequestId } = toRefs(props)
    const cancelAuditRequestModalIsShown = ref(false)
    const cancellationReason = ref('')

    const formRef = ref(null)

    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)
    const isAuditsUser = computed(() => userGetters('isAuditsUser'))

    const [auditRequestService] = useDeps(AuditRequestService)

    async function cancelRequest(e: any) {
      if (
        isAuditsUser.value &&
        !cancellationReason.value &&
        formRef.value?.$el
      ) {
        e.preventDefault()
        formRef.value.$el.reportValidity()
        return
      }
      const { auditRequest } = await auditRequestService.cancelRequest(
        auditRequestId.value,
        cancellationReason.value || undefined
      )
      emit('change-status', auditRequest.currentStatus.status)
    }

    return {
      faTimes,
      cancelAuditRequestModalIsShown,
      cancellationReason,
      cancelRequest,
      isAuditsUser,
      formRef
    }
  }
})
